import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv, SummaryDiv } from '../TextStyle'
import { pvItems, pvLinks, etItems } from './PrivacyItems'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Index } from '@/components/layouts/Legal/Index'

const sectionTitle = {
  titleText: 'Privacy Policy',
  subTitleText: '個人情報保護方針（プライバシーポリシー）',
}

const tSummary = (
  <p>
    株式会社トライアルホールディングス及びそのグループ会社※（以下「トライアルグループ」といいます。）は、お客様、お取引先様、採用選考にご応募いただく皆様及び株主様（以下併せて「お客様等」といいます。）に安心してトライアルグループの店舗、トライアルグループが提供するウェブサイト、モバイルアプリケーション及び各サービス（以下「ウェブサイト等」といいます。）をご利用いただくため、個人情報の保護に関する法律、その関係法令及びガイドライン等（以下「個人情報保護法等」といいます。）を遵守し、お客様等の個人情報を細心の注意をもって管理いたします。トライアルグループでは、個人情報の取り扱いに関する基本方針として、この個人情報保護方針（以下「本プライバシーポリシー」といいます。）を定め、トライアルグループが収集したお客様等の個人情報について、適法かつ適切な取り扱いに努めて参ります。また、ウェブサイト等をご利用いただくお客様等は、本プライバシーポリシーに同意されたことになります。
    <br />
    ※トライアルグループとは、株式会社トライアルホールディングス並びにその連結子会社及び持分法適用会社を指し、株式会社SU-PAYは除きます。株式会社SU-PAYに適用される個人情報保護方針（プライバシーポリシー）については別途定めるものとします。
    <br />
    ※本プライバシーポリシーは株式会社SU-PAYと西友ネットスーパーには適用されません。
    <br />
    <span style={{marginLeft: '16px'}}>・株式会社SU-PAYのプライバシーポリシーは<a href="https://su-pay.jp/prepaid/terms/" target="_blank" rel="noreferrer">こちら</a>です。</span>
    <br />
    <span style={{marginLeft: '16px'}}>・西友ネットスーパーのプライバシーポリシーは<a href="https://netsuper.rakuten.co.jp/seiyu/info/privacy/" target="_blank" rel="noreferrer">こちら</a>です。</span>
  </p>
)

export const PrivacyPage = () => {
  return (
    <>
      <Head
        title="プライバシーポリシー"
        description="トライアルホールディングスのプライバシーポリシーを掲載しています。"
        ogp={{ type: 'article', url: 'legal/privacy-policy/' }}
      />
      <PrivacyContainer>
        <SectionTitle
          color="normal"
          titleText={sectionTitle.titleText}
          subTitleText={sectionTitle.subTitleText}
        />
        <Spacer h={{ pc: 70, sp: 60 }} />
        <SummaryDiv>{tSummary}</SummaryDiv>
        <Spacer h={{ pc: 46, sp: 35 }} />
        <Index columnGap={84} listType="article" links={pvLinks} />
        <Spacer h={{ pc: 35, sp: 40 }} />
        {pvItems.map(({ children, id }, index, array) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < array.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}

        {/* secondsectionTitleを追加 */}
        <Spacer h={{ pc: 100, sp: 60 }} />
        <SectionTitle
          color="normal"
          enTitleText="利用者情報の外部送信について"
        />
        <Spacer h={{ pc: 70, sp: 60 }} />

        {etItems.map(({ children, id }, index, array) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < array.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </PrivacyContainer>
    </>
  )
}
PrivacyPage.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'LEGAL',
    subTitle: '法務',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '法務', path: '/legal/' },
    { name: 'プライバシーポリシー', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const PrivacyContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 68px;
  }

  #privacy7 {
    margin-top: -105px;
    padding-top: 105px;
  }

  @media screen and (max-width: 1047px) {
    #privacy7 {
      margin-top: -53px;
      padding-top: 53px;
    }
  }
`
